import { Box, Typography, Grid, CircularProgress, Divider, Card, } from '@mui/material';
import { Formik, Form } from 'formik';
import React, { useState, useEffect } from "react";
import axios from 'axios';
import { GET_INVOICE_EXPORT_PROFORMA_INVOICE, READ_SALES_ORDER_EXPORT } from '../../../services/apiRoutes';
import CustomCardView from '../../common/CustomCardView';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import DetailsParticulars from '../../common/DetailsPage/DetailsParticulars';
import CustomPrintModel from '../../common/CustomPrint';
import { convertNumberToWords, printFunction } from '../../../services/apiServices';
import {
    SalesOrderFirst,
    SalesOrderSecond,
    SalesOrderThird,
    SalesOrderFourth
} from '../PrintPdf/SalesOrderPrint';
import { genericPost } from '../../../services/authServices';
import { getRoundAmount } from '../../../services/CommonServices';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import { t } from '../../../constants/translationHelper';



const SalesOrderView = ({ handleClose, salesOrderId, templateId, expSalesPrefix, expSalesSuffix, shipmentOrgId }) => {
    const companyDateFormat = useCompanyDateFormat();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [dataParticular, setDataParticular] = useState(null);
    const [totalQty, setTotalQty] = useState(0);
    const [totalRate, setTotalRate] = useState(0);
    const [amountData, setAmount] = useState(0);
    const [amountText, setAmountText] = useState(0);

    const [termConditions, setTermConditions] = useState([]);
    const [companyBanks, setCompanyBanks] = useState([]);
    const [shipments, setShipments] = useState([]);
    const [shippingBooking, setShippingBooking] = useState([]);
    const [paymentVoucher, setPaymentVoucher] = useState([]);
    const [companyTaxes, setCompanyTaxes] = useState([]);
    const [shippingmark, setShippingmark] = useState([]);
    const [currencyName, setCurrencyName] = useState('');


    useEffect(() => {
        fetchDataInvoice();
    }, []);

    const fetchDataInvoice = async () => {
        setLoading(true);
        try {
            const payload = { shipmentOrgId: shipmentOrgId };
            const response = await genericPost(GET_INVOICE_EXPORT_PROFORMA_INVOICE, payload);
            if (response?.data?.success) {
                const resData = response.data.data;
                setTermConditions(resData.termConditions || []);
                setCompanyBanks(resData.companyBanks || []);
                setShipments(resData.shipments || []);
                setShippingBooking(resData.shippingBooking || []);
                setPaymentVoucher(resData.paymentVoucher || []);
                setCompanyTaxes(resData.companyTaxes || []);
                setShippingmark(resData.shippingmark || []);
            } else {
                setError('No data found');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError('Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!salesOrderId) return;
        const fetchData = async () => {
            try {
                const accessToken = sessionStorage.getItem('accessToken');
                const response = await axios.get(READ_SALES_ORDER_EXPORT(salesOrderId), {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                const salesOrder = response?.data?.data;
                const symbol = salesOrder?.currency?.currency_symbol || '';
                const symbolName = salesOrder?.currency?.currency_name || '';
                setData(salesOrder);
                const particulars = salesOrder.particulars.map(particular => ({
                    qty: particular.qty || 0,
                    description: particular.description || 0,
                    rate: `${symbol || ''} ${parseFloat(particular?.rate || 0).toFixed(2)}`,
                    amounts: `${symbol || ''} ${(particular.qty || 0) * (parseFloat(particular.rate) || 0)}`,
                    rowAmount: (particular.qty || 0) * (parseFloat(particular.rate) || 0),
                    productName: particular.products.productName,
                    unitName: particular.productsUnit.unitName,
                }));
                const amountTotal = particulars.reduce((acc, item) => acc + item.rowAmount, 0).toFixed(2);
                const totalAmountNumber = parseFloat(amountTotal);
                const roundedAmount = getRoundAmount(totalAmountNumber);
                setAmount(`${symbol} ${roundedAmount.toFixed(2)}`);
                setAmountText(roundedAmount);
                setDataParticular(particulars);
                setCurrencyName(symbolName);
                const totalQuantity = particulars
                    .reduce((total, particular) => total + (parseFloat(particular.qty) || 0), 0)
                setTotalQty(totalQuantity)
                setTotalRate(salesOrder.particulars.reduce((acc, item) => acc + parseFloat(item.rate), 0));
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [salesOrderId]);

    if (loading) return <CircularProgress />;
    if (error) return <p>Error: {error}</p>;

    const values = {
        salesOrderId: data?.salesOrderId || '',
        userId: data?.userId || '',
        companyId: data?.companyId || '',
        customer: data?.customer?.clientCompanyName || '',
        reference: data?.reference || '',
        salesOrderNo: `${expSalesPrefix || ''} ${data?.salesOrderNo || ''} ${expSalesSuffix || ''}`,
        date: companyDateFormat(data?.date) || '',
        dueDate: companyDateFormat(data?.dueDate) || '',
        note: data?.note || '',
        currency: data?.currency?.currency || '',
        particulars: dataParticular.map(particular => ({
            particularName: particular.particularName,
            qty: particular.qty,
            rate: particular.rate,
            unit: particular.unit,
            description: particular.description,
        })) || [],
    };

    const labels = [
        { key: 'customer', label: 'customer ', sm: 12, md: 4, },
        { key: 'dueDate', label: 'Due Date', sm: 12, md: 4, },
        { key: 'salesOrderNo', label: 'Sales Order No', sm: 12, md: 4, },
        { key: 'reference', label: 'Reference', sm: 12, md: 4, },
        { key: 'date', label: 'Date', sm: 12, md: 4, },
        { key: 'currency', label: 'currency', sm: 12, md: 4, },
    ];

    const particularsColumns = [
        {
            id: 'productName',
            label: 'Product Name',
            accessor: 'productName',
        },
        {
            id: 'qty',
            label: 'Quantity',
            accessor: 'qty',
            styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'rate',
            label: 'Rate',
            accessor: 'rate',
            styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'unitName',
            label: 'Unit',
            accessor: 'unitName',
            styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'amounts',
            label: 'Amount',
            accessor: 'amounts',
            styleAccessor: {
                textAlign: 'right',
            },
        },
    ];

    const footerData = [
        {
            label: 'Total',
            footerValue: '',
            style: {
                textAlign: 'right',
            },
            colSpan: 1,

        },
        {
            label: '',
            footerValue: totalQty,
            style: {
                textAlign: 'center',

            },

        },
        {
            label: '',
            footerValue: amountData,
            style: {
                textAlign: 'right',

            },
            colSpan: 3,

        },
    ];

    const clientCompanyName = data?.customer?.clientCompanyName || '';
    const encodedCompanyName = clientCompanyName.replace(/ /g, '').toLowerCase();
    const fileName = `sales_order_${encodedCompanyName}.pdf`;

    const printContent = () => {
        const elementId = 'contentId';
        const iframeId = 'print-iframe';
        printFunction(elementId, iframeId, fileName);

    };
    const pdfContent = () => {
        const elementId = 'contentpdf';
        const iframeId = 'print-iframe';
        printFunction(elementId, iframeId, fileName);
    };
    const invoiceTermConditions = termConditions?.find(
        (item) => item.voucherName === "2"
    )?.termConditions || "";

    // const check = parseInt(templateId);
    const footerFalse = false;
    const footerTrue = true;

    const check = parseInt(templateId);
    const getPrintContent = () => {
        if (check === 1) {
            return (
                <SalesOrderFirst
                    salesOrderNo={values.salesOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    amountInWords={amountInWords}
                    footer={footerFalse}
                />);
        }
        if (check === 2) {
            return (
                <SalesOrderSecond salesOrderNo={values.salesOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    amountInWords={amountInWords}
                    footer={footerFalse} />);
        }
        if (check === 3) {
            return (
                <SalesOrderThird salesOrderNo={values.salesOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    amountInWords={amountInWords}
                    footer={footerFalse} />);
        }
        if (check === 4) {
            return (
                <SalesOrderFourth salesOrderNo={values.salesOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    amountInWords={amountInWords}
                    footer={footerFalse} />);
        }

        return <SalesOrderFirst salesOrderNo={values.salesOrderNo}
            totalQty={totalQty}
            amountData={amountData}
            invoiceData={data}
            termConditions={invoiceTermConditions}
            companyBanks={companyBanks}
            shippingBooking={shippingBooking}
            shipments={shipments}
            paymentVoucher={paymentVoucher}
            companyTaxes={companyTaxes}
            amountInWords={amountInWords}
            footer={footerFalse} />;
    };

    const getPdfContent = () => {
        if (check === 1) {
            return (
                <SalesOrderFirst
                    salesOrderNo={values.salesOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    footer={footerTrue}
                    amountInWords={amountInWords}
                />);
        }
        if (check === 2) {
            return (
                <SalesOrderSecond salesOrderNo={values.salesOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    amountInWords={amountInWords}
                    footer={footerTrue} />);
        }
        if (check === 3) {
            return (
                <SalesOrderThird salesOrderNo={values.salesOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    amountInWords={amountInWords}
                    footer={footerTrue} />);
        }
        if (check === 4) {
            return (
                <SalesOrderFourth salesOrderNo={values.salesOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    amountInWords={amountInWords}
                    footer={footerTrue} />);
        }

        return <SalesOrderFirst salesOrderNo={values.salesOrderNo}
            totalQty={totalQty}
            amountData={amountData}
            invoiceData={data}
            termConditions={invoiceTermConditions}
            companyBanks={companyBanks}
            shippingBooking={shippingBooking}
            shipments={shipments}
            paymentVoucher={paymentVoucher}
            companyTaxes={companyTaxes}
            amountInWords={amountInWords}
            footer={footerTrue} />;
    };
    const number = amountText || '';
    const amountInWords = convertNumberToWords(number);

    return (
        <>
            <CustomPrintModel contentId="contentId">
                {getPrintContent()}
            </CustomPrintModel >

            <CustomPrintModel contentId="contentpdf">
                {getPdfContent()}
            </CustomPrintModel >

            <Box sx={{ mx: 'auto', mt: 0 }}>
                <Formik initialValues={values} enableReinitialize>
                    {() => (
                        <Form>
                            <Grid container spacing={1}>
                                <Grid item xs={4}>
                                    <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#212529" }}>
                                        {t("Sales Order")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Box>
                                        <IconButton aria-label="delete">
                                            <DeleteOutlineOutlinedIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                                        </IconButton>
                                        <IconButton aria-label="print" onClick={printContent}>
                                            <LocalPrintshopOutlinedIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                                        </IconButton>
                                        <IconButton aria-label="print" onClick={pdfContent}>
                                            <PictureAsPdfOutlinedIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                                        </IconButton>
                                        <IconButton aria-label="close" onClick={handleClose} >
                                            <CloseIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                                        </IconButton>
                                    </Box>

                                </Grid>
                            </Grid>
                            <Divider />
                            <Grid container spacing={0} sx={{ px: "0%" }}>
                                <Grid item xs={12}>
                                    <CustomCardView title="Bill To" label={labels} data={values} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Box display="flex" flexDirection="row" alignItems="center">
                                        <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                                            {t("Particulars")}
                                        </Typography>
                                    </Box>
                                    <DetailsParticulars
                                        title={'Particulars'}
                                        columns={particularsColumns}
                                        data={dataParticular}
                                        footerData={footerData}
                                    />
                                </Grid>
                                <Grid item xs={7}>
                                    <br />
                                    <Box>
                                        <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px" }}>
                                            {t("In Words")}
                                        </Typography>
                                        <Typography style={{ color: "#212529", fontWeight: 400, fontSize: "14px", textTransform: "uppercase" }}>
                                            {currencyName} {amountInWords}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ pt: 5 }}>
                                        <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px" }}>
                                            {t("Note")} :
                                        </Typography>
                                        <Typography style={{ color: "#212529", fontWeight: 400, fontSize: "14px", textTransform: "capitalize" }}>
                                            {values.note}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={5}>
                                    <br />
                                    <Box display="flex" flexDirection="row" alignItems="center">
                                        <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                                            {t("Summary")}
                                        </Typography>
                                    </Box>
                                    <Card sx={{ padding: 2, display: 'flex', flexDirection: 'column', gap: 1, maxWidth: 400 }} variant="outlined">
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography>{t("Total Quantity")}:</Typography>
                                            <Typography>{totalQty}</Typography>
                                        </Box>

                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography>{t("Amount")}:</Typography>
                                            <Typography>{amountData}</Typography>
                                        </Box>

                                        <Divider sx={{ my: 0 }} />
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography fontWeight="bold">{t("Grand Total")}:</Typography>
                                            <Typography fontWeight="bold">{amountData}</Typography>
                                        </Box>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
        </>
    );
};

export default SalesOrderView;
